import {
    NinchatCodeForkIcon, NinchatCodeIcon, NinchatGithubIcon,
} from 'components/Icon'
import {
    styledAction,
    styledName,
} from './styles'
import {NinchatStoreMessage} from 'api/types/store'
import React from 'react'
import {styled} from 'stitches/config'

const StyledAction = styled('span', styledAction)
const StyledName = styled('span', styledName)

const PullRequestView = (props: {message: NinchatStoreMessage}): React.ReactElement => {
    const {message} = props

    return (
        <ul>
            <li>
                <a href={message.repository?.url} rel='noopener noreferrer' target='_blank'>
                    <StyledName><NinchatGithubIcon size={16} /><span>{message.repository?.full_name}</span></StyledName>
                </a>
                <StyledName>({message.sender?.login}):</StyledName>
                <StyledAction>{`[${message.action}]`}</StyledAction>

                {!!message.pull_request &&
                    <>
                        <a
                            href={message.pull_request.html_url}
                            rel='noopener noreferrer'
                            target='_blank'
                        >
                            <NinchatCodeForkIcon size={16} />{message.text}
                        </a>
                        <span>{message.pull_request?.title} <a href={message.pull_request?.html_url} rel='noopener noreferrer' target='_blank'><NinchatCodeIcon size={16} /></a></span>
                    </>}
            </li>
        </ul>
    )
}

export default PullRequestView
